import { Reaction } from 'interfaces/Reaction'

export const getTotalReactionCount = (reactions: Reaction[]) =>
    reactions.reduce((accumulator, reaction) => accumulator + reaction.count, 0)
